import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { routes } from 'routes';
import PrivateRoute from 'routes/PrivateRoute';

// This should be hidden as long as required by the Product Owner
// import PriceView from 'pages/PriceView';
import CatalogConsentView from './CatalogConsentView';
import HomeView from './HomeView/HomeView';
import ListResultsView from './ListResultsView';
import NewsView from './NewsView/NewsView';
// This should be hidden as long as required by the Product Owner
// import PriceListView from './PriceListView';
import { NewPriceListView } from './NewPriceListView';
import SignInView from './SignInView/SignInView';
import SingleProductView from './SingleProductView/SingleProductView';

const Root = () => {
   return (
      <BrowserRouter>
         <Routes>
            <Route path={routes.home} element={<HomeView />} />
            <Route path={routes.signIn} element={<SignInView />} />
            <Route
               path={routes.catalogConsent}
               element={<PrivateRoute path={routes.catalogConsent} />}
            >
               <Route path="" element={<CatalogConsentView />} />
            </Route>
            <Route path="" element={<PrivateRoute />}>
               <Route path={routes.catalogModel} element={<ListResultsView />} />
               <Route path={routes.catalogProduct} element={<SingleProductView />} />
               <Route path="/instrukcje/:instructionId" element={<NewsView />} />
            </Route>
            <Route path={routes.priceList} element={<NewPriceListView />} />
            <Route path={routes.priceListProduct} element={<NewPriceListView />} />
            <Route path="/news/:newsId" element={<PrivateRoute path="/news/:newsId" />}>
               <Route path="" element={<NewsView />} />
            </Route>
         </Routes>
      </BrowserRouter>
   );
};

export default Root;
